import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { searchFormItems } from './config';
import { PAGE_URL, updateLoginPermission } from '@/api/appletuser/appletuser';
import { toast } from '@/utils/message';
import { COMMON_ENABEL_STATUS } from '@/constant/system/code';
import { XTable } from '@/components/index';
import useStore from "@/store";

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Appletuser',
  setup: function setup(__props) {
    var tableInstance = ref();
    var searchData = {};
    var headerButton = [];
    function search(formDara) {
      var _tableInstance$value;
      searchData = formDara;
      (_tableInstance$value = tableInstance.value) === null || _tableInstance$value === void 0 || _tableInstance$value.load(formDara);
    }
    function reset() {
      var _tableInstance$value2;
      searchData = {};
      (_tableInstance$value2 = tableInstance.value) === null || _tableInstance$value2 === void 0 || _tableInstance$value2.load({});
    }
    function tableReLoad() {
      var _tableInstance$value3;
      (_tableInstance$value3 = tableInstance.value) === null || _tableInstance$value3 === void 0 || _tableInstance$value3.load(searchData);
    }
    /**
     * 格式化性别显示
     * @param sexCode
     */
    function formatterSex(sexCode) {
      switch (sexCode) {
        case 'F':
          return '女';
        case 'M':
          return '男';
        default:
          return '未知';
      }
    }
    /**
     * 编辑登录许可权限
     */
    var loginPermissionEnable = computed(function () {
      if (useStore().user.actions.filter(function (item) {
        return item.authorityCode === 'manage:applet-user:updateLoginPermission';
      }).length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 修改登录许可状态
     * @param row
     */
    function handleUpdateLoginPermission(row) {
      updateLoginPermission({
        'id': row.id,
        'loginPermission': row.loginPermission
      }).then(function () {
        toast.success('操作成功');
        tableReLoad();
      });
    }
    return function (_ctx, _cache) {
      var _component_XSearchForm = _resolveComponent("XSearchForm");
      var _component_ElAvatar = _resolveComponent("ElAvatar");
      var _component_ElTableColumn = _resolveComponent("ElTableColumn");
      var _component_ElSwitch = _resolveComponent("ElSwitch");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_XSearchForm, {
            ref: "searchForm",
            items: _unref(searchFormItems),
            onSearch: search,
            onReset: reset
          }, null, 8, ["items"]), _createVNode(_unref(XTable), {
            ref_key: "tableInstance",
            ref: tableInstance,
            url: _unref(PAGE_URL),
            "show-index": "",
            selectable: false,
            "header-buttons": headerButton,
            "el-table-props": {
              border: true
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_ElTableColumn, {
                label: "头像",
                prop: "avatarCode",
                align: "center",
                width: "80px"
              }, {
                default: _withCtx(function (_ref) {
                  var row = _ref.row;
                  return [_createVNode(_component_ElAvatar, {
                    src: row.avatarCode,
                    shape: "square",
                    size: "small"
                  }, null, 8, ["src"])];
                }),
                _: 1
              }), _createVNode(_component_ElTableColumn, {
                label: "姓名",
                prop: "name",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "手机",
                prop: "telPhone",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "船号",
                prop: "shipNum",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "性别",
                prop: "sex",
                formatter: function formatter(row) {
                  return formatterSex(row.sex);
                },
                align: "center"
              }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
                label: "登录许可",
                prop: "loginPermission",
                align: "center"
              }, {
                default: _withCtx(function (_ref2) {
                  var row = _ref2.row;
                  return [_createVNode(_component_ElSwitch, {
                    modelValue: row.loginPermission,
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return row.loginPermission = $event;
                    },
                    disabled: _unref(loginPermissionEnable),
                    "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
                    "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
                    onChange: function onChange($event) {
                      return handleUpdateLoginPermission(row);
                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "active-value", "inactive-value", "onChange"])];
                }),
                _: 1
              }), _createVNode(_component_ElTableColumn, {
                label: "创建时间",
                prop: "createdAt",
                align: "center"
              })];
            }),
            _: 1
          }, 8, ["url"])];
        }),
        _: 1
      });
    };
  }
});